export default __webpack_public_path__ + "static/media/javascript.15c80db8.svg";